/**
 * Syncs waiting for the network (git sync Stage 1, card 7 set 7d — owner plan:
 * "offline commits push when back online").
 *
 * A sync commits locally before it pushes; when the push fails because there is
 * no network, the commit is kept and the workspace id lands here. The queue is
 * retried when the app is back online (hooks/useGitOfflineQueue.js) and an id
 * leaves it on the next successful sync. Kept per device in localStorage — it
 * only ever holds workspace ids, never content.
 */
const KEY = 'apiboo.git.offlineQueue';

/**
 * True when a sync failed because the machine could not reach the remote at
 * all — not for auth failures, a rejected push or a bad repository.
 */
export function isOfflineError(err, online = typeof navigator === 'undefined' ? true : navigator.onLine) {
  if (online === false) return true;
  const msg = String(err?.message || err || '').toLowerCase();
  return /could not resolve|couldn't resolve|failed to resolve|name or service not known|no such host|failed to connect|could not connect|connection refused|connection reset|network is unreachable|network unreachable|timed out|timeout|offline|dns/.test(msg);
}

export function queuedIds() {
  try {
    const list = JSON.parse(localStorage.getItem(KEY) || '[]');
    return Array.isArray(list) ? list.map(String) : [];
  } catch {
    return [];
  }
}

function save(list) {
  try {
    localStorage.setItem(KEY, JSON.stringify([...new Set(list)]));
  } catch {
    /* private window / blocked storage: the queue lives until reload */
  }
}

export function enqueue(id) {
  if (id == null) return;
  save([...queuedIds(), String(id)]);
}

export function dequeue(id) {
  save(queuedIds().filter((x) => x !== String(id)));
}
